module.exports = __webpack_public_path__ + "img/34.db05c86f.jpg";